import { render } from "./FormItemCard.vue?vue&type=template&id=5cb3116f&scoped=true&ts=true"
import script from "./FormItemCard.vue?vue&type=script&lang=ts"
export * from "./FormItemCard.vue?vue&type=script&lang=ts"

import "./FormItemCard.vue?vue&type=style&index=0&id=5cb3116f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb3116f"]])

export default __exports__